/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

import { ERROR_OK, ERROR_RESOLVABLE_BY, ERROR_TYPES } from './ChannelErrorDefType';

export const MAX_STORED_FETCHES = 50;

export default declareEntity({
    entity: "channelErrors",
    graphQL: "ChannelError",
    name: "Channel Error",
    dynamoPrefix: 'org',
    storageType: 'central',
    defaultOrder: [['lastTransferAt', 'desc']],
    parentRelation: 'channelErrorDefs',
    fields: (types) => { return {
        id: {
            name: "Channel Error ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        channelDef: {
            name: "Application Definition",
            to: () => types['channelDefs'],
            type: "relation",
            defaultValue: (channel) => {
                return channel['channelDef_id'];
            },
        },
        channel: {
            name: "Application",
            to: () => types['channels'],
            type: "relation",
            defaultValue: (channel) => {
                return channel['id'];
            },
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        flow: {
            name: "Flow",
            type: "relation",
            to: () => types['flows'],
        },
        flowDef: {
            name: "Flow Definition",
            type: "relation",
            to: () => types['flowDefs'],
        },
        entityDefKey: {
            name: "Entity Definition Key",
            type: "string",
        },
        sourceDef: {
            name: "Data Source",
            type: "relation",
            to: () => types['sourceDefs'],
            controllerFn: "getSourceDef",
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
            userEditable: false,
            hiddenCreate: true,
            defaultValue: (channel) => {
                if (channel) {
                    return channel['instance_id'];
                }
            },
        },
        organisation: {
            name: "Organisation ID",
            type: "relation",
            to: () => types['organisations'],
            defaultValue: (channel) => {
                return channel['organisation_id'];
            },
            required: true,
            hiddenCreate: true,
        },
        ignoredError: {
            name: "Ignored error",
            type: "boolean",
            filterable: true,
            defaultValue: false,
        },
        ignoreForFuture: {
            name: "Ignore for future",
            type: "boolean",
            filterable: true,
            defaultValue: false,
        },
        comment: {
            name: "Comment",
            type: "string",
            defaultValue: "",
        },
        externalId: {
            name: "External ID",
            type: "string",
            defaultValue: "",
            filterable: true,
        },
        displayName: {
            name: "Display Name",
            type: "string",
            defaultValue: "",
            filterable: true,
        },
        referencedId: {
            name: "Order number",
            type: "string",
            defaultValue: "",
            filterable: true,
        },
        hasError: {
            name: "Has error",
            type: "boolean",
            defaultValue: false,
            filterable: true,
        },
        lastError: {
            name: "Last error",
            description: "User friendly error message",
            type: "string",
            defaultValue: "",
        },
        lastErrorObject: {
            name: "Last error Object",
            description: "Raw error object",
            type: "string",
            defaultValue: "",
        },
        channelErrorDef: {
            name: "Channel Error Definition",
            to: () => types['channelErrorDefs'],
            type: "relation",
            relativeTo: ['channelDef'],
        },
        channelErrorParams: {
            name: "Params for channel error",
            type: "object",
        },
        channelErrorMessage: {
            name: "Channel Error Title",
            type: "string",
            defaultValue: "",
        },
        channelErrorField: {
            name: "Channel Error Field",
            type: "string",
            defaultValue: "",
        },
        channelErrorRaw: {
            name: "Channel Error Raw",
            type: "text",
        },
        type: {
            name: "Type",
            type: "enum",
            values: ERROR_TYPES,
            defaultValue: () => {
                return ERROR_OK;
            },
            filterable: true, 
        },
        objectDate: {
            name: "Object Date",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        resolvableBy: {
            name: "Resolvable by",
            type: "enum",
            values: ERROR_RESOLVABLE_BY,
            filterable: true,
        },
        firstTransferAt: {
            name: "First transfered At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        firstTransfer: {
            name: "First transfer",
            type: "relation",
            to: () => types['fetches'],
            userEditable: false,
        },
        lastTransferAt: {
            name: "Last transfered At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        lastTransfer: {
            name: "Last transfer",
            type: "relation",
            to: () => types['fetches'],
            userEditable: false,
        },
        lastErrorTransferAt: {
            name: "Last error At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        lastErrorTransfer: {
            name: "Last error transfer",
            type: "relation",
            to: () => types['fetches'],
            userEditable: false,
        },
        lastSuccessTransferAt: {
            name: "Last success At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        lastSuccessTransfer: {
            name: "Last success transfer",
            type: "relation",
            to: () => types['fetches'],
            userEditable: false,
        },
        lastTransfers: {
            name: "Last transfers",
            type: "object",
            userEditable: false,
        },
        transferCount: {
            name: "Transfer count",
            type: "int",
            defaultValue: 0,
            userEditable: false,
        },
        errorCount: {
            name: "Error count",
            type: "int",
            defaultValue: 0,
            userEditable: false,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
        lastTransferFetches: {
            name: "Last transfer Fetches",
            type: 'handler',
            to: types['fetches'],
            controllerFn: "getLastTransferFetches",
        },
    }; }
});
